<template>
    <el-container style="height:100%">
        <el-aside class="menu">
            <div class="imgLogo clear_a">
                <img :src="logoUrl">
                <p class="ml10">{{logoTitle}}</p>
            </div>
            <div class="homeMenu">
                <el-scrollbar style="height:100%">
                    <el-menu :default-active="index">
                        <router-link :to="item.childrenShow ? '':item.route" v-show='roles.includes(item.role)&& item.show === true'
                                     :key='item.role+index' v-for='(item,index) in menu[headIndex]'>
                            <el-menu-item :index="item.route" v-if="!item.childrenShow">
                                <i class="iconfont" :class="item.icon" style="margin:0 12px 0 5px"></i>
                                <span slot="title">{{item.name}}</span>
                            </el-menu-item>
                            <el-submenu index="2" v-if="item.childrenShow">
                                <template slot="title">{{item.name}}</template>
                                <router-link :to="itemC.route" v-for='(itemC,indexC) in item.childrenList' :key='itemC.role+indexC'>
                                    <el-menu-item :index="itemC.route">{{itemC.name}}</el-menu-item>
                                </router-link>
                            </el-submenu>
                        </router-link>
                    </el-menu>
                </el-scrollbar>
            </div>
            <div class="schoolName">
                <p>{{info.schoolName}}</p>
            </div>
        </el-aside>

        <el-container>
            <el-header style="text-align: right; font-size: 12px">
                <el-col :span="20">
                    <el-menu :default-active="headIndex" class="el-menu-demo" mode="horizontal" @select="menuSelect">
                        <el-menu-item v-if='item.role=="default"||roles.includes(item.role)' v-for='item in headMenu' :key="item.key"
                                      :index="item.key" @click="$router.push({path:item.defaultPath})">{{item.name}}
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="4">
                    <el-dropdown>
                        <span>{{info.name}} <i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item>查看</el-dropdown-item>
                        <el-dropdown-item>新增</el-dropdown-item> -->
                            <span @click="logOut">
                                <el-dropdown-item>退出</el-dropdown-item>
                            </span>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-header>

            <el-main class="main">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import logoSrc from "../assets/img/mealLogo.png"
import * as storage from "utils/sessionStorage";
import * as api from '../api/com'
import * as warningApi from 'api/warning_v3.js';
import * as warningApi2 from 'api/warning_v2.js';

export default {
    name: "home",
    data() {
        return {
            logoUrl: '',
            logoTitle: '',
            headIndex: 'kitchenManage',
            index: "/kitchenManage/school",
            info: {
                name: this.$store.state.common.user.realName,
                schoolName: this.$store.state.common.user.deptName
            },
            accountType: '',
            headMenu: [{
                name: '后厨管理',
                key: 'kitchenManage',
                defaultPath: '/kitchenManage/school',
                role: 'default'
            }, {
                name: "明厨亮灶",
                key: "camera",
                defaultPath: "/camera/liveList",
                role: "40"
            }
            ],
            menu: {
                'kitchenManage': [{
                    name: "主体信息维护",
                    icon: "iconschool",
                    route: "/kitchenManage/school",
                    moduleString: '',
                    show: false,
                    role: "default"
                },
                {
                    name: "评价管理",
                    icon: "iconmanagement",
                    route: "/kitchenManage/commentManage",
                    moduleString: '',
                    show: false,
                    role: "22"
                },
                // {
                //   name: "人员管理",
                //   icon: "iconmanagement",
                //   route: "/kitchenManage/person",
                //   moduleString:'',
                //   show:false,
                //   role: "00"
                // },
                // {
                //   name: "每日菜谱",
                //   icon: "iconmenu",
                //   route: "/kitchenManage/menu",
                //   moduleString:'everyday_menu',
                //   show:false,
                //   role: "08"
                // },
                // {
                //   name: "晨检",
                //   icon: "iconannouncement",
                //   route: "/kitchenManage/inspect",
                //   moduleString:'morning_inspection',
                //   show:false,
                //   role: "01"
                // },
                // {
                //   name: "清洗消毒",
                //   icon: "iconcleaning",
                //   route: "/kitchenManage/clean",
                //   moduleString:'cleaning_and_disinfection',
                //   show:false,
                //   role: "02"
                // },
                // {
                //   name: "食品留样",
                //   icon: "iconsample",
                //   route: "/kitchenManage/reserved",
                //   moduleString:'food_sample',
                //   show:false,
                //   role: "03"
                // },
                // {
                //   name: "校长陪餐",
                //   icon: "iconchopsticks",
                //   route: "/kitchenManage/accompany",
                //   moduleString:'principal_accompanying_meal',
                //   show:false,
                //   role: "05"
                // },
                // {
                //   name: "餐厨垃圾",
                //   icon: "icontrash",
                //   route: "/kitchenManage/trash",
                //   moduleString:'kitchen_waste',
                //   show:false,
                //   role: "04"
                // },
                // {
                //   name: "培训记录",
                //   icon: "icontraining",
                //   route: "/kitchenManage/training",
                //   moduleString:'training_record',
                //   show:false,
                //   role: "06"
                // },
                // {
                //   name: "配置中心",
                //   icon: "iconsetting",
                //   route: "/kitchenManage/setting",
                //   moduleString:'',
                //   show:false,
                //   role: "00"
                // },
                {
                    name: "投诉反馈",
                    icon: "iconcomplaint",
                    route: "/kitchenManage/feedback",
                    moduleString: 'complaint_feedback',
                    show: false,
                    role: "09"
                },
                {
                    name: "规章制度管理",
                    icon: "iconrule",
                    route: "/kitchenManage/regulation",
                    moduleString: 'regulation',
                    show: false,
                    role: "19"
                },
                {
                    name: "索票索证",
                    icon: "iconbill",
                    route: "/kitchenManage/ticket",
                    moduleString: 'asking_for_tickets',
                    show: false,
                    role: "20"
                },
                {
                    name: "子食堂管理",
                    icon: "iconrule",
                    route: "/kitchenManage/subCanteen",
                    moduleString: 'sub_canteen',
                    show: false,
                    role: "23"
                },
                {
                    name: "来源填报",
                    icon: "iconrule",
                    role: '26',
                    moduleString: 'origin_provided',
                    show: false,
                    childrenShow: true,
                    childrenList: [{
                        name: "商品填报",
                        icon: "iconrule",
                        route: "/kitchenManage/sourceFill/goodsFill",
                        moduleString: 'goodsFill',
                        show: false,
                        role: "19",
                    }, {
                        name: "供应商管理",
                        icon: "iconrule",
                        route: "/kitchenManage/sourceFill/supplierFill",
                        moduleString: 'regulation',
                        show: false,
                        role: "19",
                    }, {
                        name: "来源管理",
                        icon: "iconrule",
                        route: "/kitchenManage/sourceFill/sourceFill",
                        moduleString: 'regulation',
                        show: false,
                        role: "19",
                    }, {
                        name: "常用商品管理",
                        icon: "iconrule",
                        route: "/kitchenManage/sourceFill/oftenGoodsFill",
                        moduleString: 'regulation',
                        show: false,
                        role: "19",
                    }, {
                        name: "库存台账",
                        icon: "iconrule",
                        route: "/kitchenManage/sourceFill/inventoryBook",
                        moduleString: 'regulation',
                        show: false,
                        role: "19",
                    }
                        // ,{
                        //   name: "溯源检测",
                        //   icon: "iconrule",
                        //   route: "/kitchenManage/sourceFill/detectionIndex",
                        //   moduleString: 'regulation',
                        //   show: false,
                        //   role: "19",
                        // }
                    ]
                },
                ],
                'warning': [],
                'warning2.0': [],
                "camera": [
                    {
                        name: "直播列表",
                        icon: "iconzhiboliebiao",
                        route: "/camera/liveList",
                        show: true,
                        role: "40"
                    },
                    {
                        name: "摄像头绑定",
                        icon: "iconshexiangtoubangding",
                        route: "/camera/cameraManager",
                        show: true,
                        role: "40"
                    }
                ]

            },
            roles: this.$store.state.common.user.roles
        };
    },
    methods: {
        menuSelect(key, keyPath) {
            this.headIndex = key;
            for (let i in this.menu[this.headIndex]) {
                if (this.roles.includes(this.menu[this.headIndex][i].role) || this.menu[this.headIndex][i].role === 'default') {
                    this.$router.push({
                        path: this.menu[this.headIndex][i].route
                    });
                    this.index = this.menu[this.headIndex][i].route
                    return;
                }
            }
        },
        logOut() {
            this.$store.dispatch("logout");
            localStorage.removeItem('accessTokenE')
        },
        async getSettingModule() {
            let result = await api.getModule()
            if (result.code === 200) {
                let data = result.data.filter(item => { return item.groupString === 'function_module' })
                this.menu.kitchenManage.map(item => {
                    item.show = false
                    item.moduleString === '' ? item.show = true : ''
                    data.map(moduleItem => {
                        moduleItem.moduleString === item.moduleString ? item.show = true : ''
                    })
                })
            }
        },
        // 动态生成 预警处理菜单
        async createWarningMenu() {
            var code = this.$store.state.common.user.areaId.substring(0,4)
            // if(code == '5116'||code == '5117'){ //广安 达州跳转预警2.0
            if(code == '5117'){ //达州跳转预警2.0
                // 头部菜单信息
                var warningHeadMenu = {
                    name: '预警处理',
                    key: 'warning2.0',
                    defaultPath: '',
                    role: "21"
                }
                // 预警子菜单 
                var warningMenu = {
                    "0101": { name: "", icon: "iconfood", route: "/warning2.0/food", show: true, role: "21" },
                    "0302": { name: "", icon: "iconhealth", route: "/warning2.0/healthCert", show: true, role: "21" },
                    "0303": { name: "", icon: "iconlicense", route: "/warning2.0/licence", show: true, role: "21" },
                    "0102": { name: "", icon: "icontraceability", route: "/warning2.0/trace", show: true, role: "21" },
                    "0201": { name: "", icon: "icondetection", route: "/warning2.0/check", show: true, role: "21" },
                    "0401": { name: "", icon: "iconsuggestion", route: "/warning2.0/complaint", show: true, role: "21" },
                    "0301": { name: "", icon: "iconsupervise", route: "/warning2.0/supervise", show: true, role: "21" },
                    "0103": { name: "", icon: "iconkitchen", route: "/warning2.0/kitchen", show: true, role: "21" },
                    "0202": { name: "", icon: "iconcamera", route: "/warning2.0/AIWarn", show: true, role: "21" },
                }
                var assessStatistics = { name: "预警考核统计", icon: "iconstatistical", route: "/warning2.0/assessStatistics", show: true, role: "21" };
                let warningMenuArr = [];

                let data = await warningApi2.getWarningTypeByEntityId({entityId: this.$store.state.common.user.deptId});

                if (data.code == 200 && data.data && data.data.length > 0) {
                    let roles = data.data; // 后台返回菜单列表
                    this.menu.warning = [];

                    // 拼接子标签 （依据 warningMenu 顺序拼接, 更新name值）
                    Object.keys(warningMenu).forEach(itemMenuCode => {
                        roles.forEach(role => {
                        if(role.key == itemMenuCode){
                            warningMenu[itemMenuCode].name = role.value;
                            warningMenuArr.push(warningMenu[itemMenuCode]);
                        }
                        })
                    })

                    warningMenuArr.push(assessStatistics)

                    // 设置首选菜单、 生成头部菜单
                    warningHeadMenu.defaultPath = warningMenuArr[0].route;
                    this.headMenu.splice(1, 0, warningHeadMenu);

                }

                this.menu["warning2.0"] = warningMenuArr;
            }else{
                // 头部菜单信息
                var warningHeadMenu = {
                    name: '预警处理',
                    key: 'warning',
                    defaultPath: '',
                    role: "21"
                }
                // 预警子菜单 
                var warningMenu = {
                    "0101": { name: "", icon: "iconfood", route: "/warning/food", show: true, role: "21" },
                    "0302": { name: "", icon: "iconhealth", route: "/warning/healthCert", show: true, role: "21" },
                    "0303": { name: "", icon: "iconlicense", route: "/warning/licence", show: true, role: "21" },
                    "0102": { name: "", icon: "icontraceability", route: "/warning/trace", show: true, role: "21" },
                    "0201": { name: "", icon: "icondetection", route: "/warning/check", show: true, role: "21" },
                    "0401": { name: "", icon: "iconsuggestion", route: "/warning/complaint", show: true, role: "21" },
                    "0301": { name: "", icon: "iconsupervise", route: "/warning/supervise", show: true, role: "21" },
                    "0103": { name: "", icon: "iconkitchen", route: "/warning/kitchen", show: true, role: "21" },
                    "0202": { name: "", icon: "iconcamera", route: "/warning/AIWarn", show: true, role: "21" },
                }
                var assessStatistics = { name: "预警考核统计", icon: "iconstatistical", route: "/warning/assessStatistics", show: true, role: "21" };
                let warningMenuArr = [];

                let data = await warningApi.getWarningTypeByEntityId({entityId: this.$store.state.common.user.deptId});

                if (data.code == 200 && data.data && data.data.length > 0) {
                    let roles = data.data; // 后台返回菜单列表
                    this.menu.warning = [];

                    // 拼接子标签 （依据 warningMenu 顺序拼接, 更新name值）
                    Object.keys(warningMenu).forEach(itemMenuCode => {
                        roles.forEach(role => {
                        if(role.key == itemMenuCode){
                            warningMenu[itemMenuCode].name = role.value;
                            warningMenuArr.push(warningMenu[itemMenuCode]);
                        }
                        })
                    })

                    warningMenuArr.push(assessStatistics)

                    // 设置首选菜单、 生成头部菜单
                    warningHeadMenu.defaultPath = warningMenuArr[0].route;
                    this.headMenu.splice(1, 0, warningHeadMenu);

                }

                this.menu["warning"] = warningMenuArr;
            }
        },
    },
    watch: {
        $route(to, from) {
            // console.log(to, from);
            this.headIndex = this.$route.path.slice(1, this.$route.path.indexOf('/', 1));
            this.headIndex = this.headIndex == 'sourceFill' ? 'kitchenManage' : this.headIndex;
            this.index = this.$route.path;
        }
    },
    async mounted() {
        await this.createWarningMenu();
        this.accountType = storage.getData('loginType')
        if (this.$store.state.common.user.buyerType == 'XJBT') {
            this.menu['kitchenManage'] = this.menu['kitchenManage'].concat([{
                name: "就餐人员管理",
                icon: "iconwhite_list",
                route: "/kitchenManage/mealPersonnel",
                moduleString: '',
                show: true,
                role: "18"
            }])
        } else if (this.accountType === 'merchant') {
            //不添加菜单
        } else {
            this.menu['kitchenManage'] = this.menu['kitchenManage'].concat([{
                name: "白名单管理",
                icon: "iconwhite_list",
                route: "/kitchenManage/whiteList",
                moduleString: '',
                show: true,
                role: "17"
            },
            {
                name: "家长访问审核",
                icon: "iconexamine",
                route: "/kitchenManage/viewAudit",
                moduleString: '',
                show: true,
                role: "00"
            }
            ])
        }
        this.getSettingModule()
        console.log(this.$route.path);
        if (this.$route.path == "/" || this.$route.path == "/home") {
            this.roles = this.$store.state.common.user.roles;
            this.menuSelect('kitchenManage')
        }
        this.headIndex = this.$route.path.slice(1, this.$route.path.indexOf('/', 1))
        this.index = this.$route.path;
    },
    async created() {
        let path = "";
        if (storage.getData('loginType') === 'merchant') {
            path = '/login1'
        } else if (storage.getData('loginType') === '') {
            path = '/login'
        }
        let res = await api.getHomeConfig({
            domainName: document.domain + path
        })
        if (res.code === 200) {
            this.logoUrl = res.data && res.data.afterLogoUrl ? res.data.afterLogoUrl : logoSrc;
            this.logoTitle = res.data && res.data.simpleName ? res.data.simpleName : (this.accountType === 'merchant' ? '放心食安管理端' : '校餐卫士学校端');
            document.title = res.data && res.data.fullName ? res.data.fullName : '';
        } else {
            this.logoUrl = logoSrc;
            this.logoTitle = this.accountType === 'merchant' ? '放心食安管理端' : '校餐卫士学校端';
        }
    },
    beforeRouteEnter(to, from, next) {
        const { path } = to;
        // 路由权限控制
        next(vm => {
            const { menu, roles } = vm;
            let isAllow = false; // 是否有权限

            // 判断路由是否存在菜单表中
            for (const key in menu) {
                if (Object.hasOwnProperty.call(menu, key)) {
                    const menuItemArr = menu[key];
                    for (let i = 0; i < menuItemArr.length; i++) {
                        const menuItem = menuItemArr[i];
                        if (menuItem.route === path && (roles.includes(menuItem.role) || menuItem.role === 'default')) {
                            isAllow = true;
                            return true;
                        }
                    }
                }
            }

            // 当前路由不存在
            if (isAllow === false) {
                console.log(`the isAllow is false, don\`t allow !`);
                vm.roles = vm.$store.state.common.user.roles;
                // vm.menuSelect("kitchenManage");
            }

        })
    }
};
</script>

<style scoped lang="scss">
.el-header {
    background-color: #fff;
    color: #333;
    line-height: 60px;
    box-shadow: 0 2px 4px 0 rgba(221, 221, 221, 0.5);
}

.el-aside {
    color: #333;
}

.el-menu {
    border: none;
}

.menu {
    height: 100%;
    width: 240px !important;
    background-color: #fff;
    box-shadow: 2px 0 4px 0 rgba(221, 221, 221, 0.5) !important;

    .imgLogo {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        width: 100%;
        height: 60px;

        img {
            width: 26px;
            height: 30px;
        }

        > p {
            font-size: 18px;
            font-family: AlibabaPuHuiTiR;
            color: rgba(112, 206, 151, 1);
            line-height: 26px;
        }
    }

    .homeMenu {
        height: calc(100% - 160px);
        width: 100%;
    }

    .schoolName {
        height: 100px;
        width: 100%;
        text-align: center;
        padding: 40px 30px;
        box-sizing: border-box;

        > p {
            box-sizing: border-box;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
        }
    }
}

.main {
    background: #f6f6f6;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}
</style>
<style>
.el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-menu-item {
    height: 50px;
}

.el-menu-demo {
    width: 70%;
}
</style>